module.exports = __webpack_public_path__ + "static/media/logo-icon.bb1d58ae.png";